/*esto fue agregado 16hs 4-12-25 la ultima actualizacion*/

import React, { createContext, useState, useContext } from 'react';
import { initialRecentOrders, initialSavedCards, initialStores } from '../data/initialData';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [recentOrders, setRecentOrders] = useState(initialRecentOrders);
  const [savedCards, setSavedCards] = useState(initialSavedCards);
  const [stores] = useState(initialStores);

  const addToCart = (item) => {
    setCartItems(prev => {
      const existingItem = prev.find(cartItem => 
        cartItem.id === item.id && 
        cartItem.size === item.size &&
        cartItem.sweetness === item.sweetness &&
        cartItem.takeaway === item.takeaway
      );
      
      if (existingItem) {
        return prev.map(cartItem =>
          cartItem.id === item.id && 
          cartItem.size === item.size &&
          cartItem.sweetness === item.sweetness &&
          cartItem.takeaway === item.takeaway
            ? { 
                ...cartItem, 
                quantity: cartItem.quantity + item.quantity,
                total: cartItem.total + item.total
              } 
            : cartItem
        );
      }
      
      return [...prev, { 
        ...item, 
        cartId: Date.now(),
        addedAt: new Date().toISOString()
      }];
    });
  };

  const removeItem = (cartId) => {
    setCartItems(prev => prev.filter(item => item.cartId !== cartId));
  };

  const updateQuantity = (cartId, newQuantity) => {
    if (newQuantity < 1) {
      removeItem(cartId);
      return;
    }
    
    setCartItems(prev =>
      prev.map(item =>
        item.cartId === cartId ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const getCartTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const addOrder = (order) => {
    setRecentOrders(prev => [order, ...prev]);
  };

  const updateSelectedStore = (store) => {
    setSelectedStore(store);
  };

  const getStores = () => stores;

  const value = {
    cartItems,
    recentOrders,
    savedCards,
    stores,
    selectedStore,
    addToCart,
    removeItem,
    updateQuantity,
    clearCart,
    getCartTotal,
    addOrder,
    updateSelectedStore,
    getStores
  };

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};
